import { useFormContext } from 'react-hook-form';

import { ISubmissionFormData } from 'src/contexts/FormContext';

import AuthorCard from './AuthorCard';
import { IAuthorWithEmail } from '@publishing-engine/domain/models';
import { FormFieldContactAuthor } from '@publishing-engine/domain/types/article';
import { useState } from 'react';
import { AuthorEditModal } from './AuthorEditModal';

const ContactAuthor = ({ config }: { config: FormFieldContactAuthor }) => {
  const { watch, setValue, trigger } = useFormContext<ISubmissionFormData>();

  const authors = (watch('metadata.authors') as IAuthorWithEmail[]) || [];
  const userEmail = watch('contactAuthor');
  const authorsWithSubmissionUser = authors.filter(
    author => author.firstName && author.lastName
  );
  const user = authorsWithSubmissionUser.find(
    author => author.email === userEmail
  )!;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const {
    params: { labels }
  } = config;

  const handleSaveChanges = async (selectedEmail: string) => {
    setValue('contactAuthor', selectedEmail);
    await trigger('contactAuthor'); // Trigger validation and re-render
    setIsEditing(false);
  };

  const handleEditClick = (isEditing: boolean) => {
    if (isEditing) {
      setIsModalOpen(true);
    } else {
      setIsEditing(isEditing);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleModalConfirm = () => {
    setIsEditing(true);
    setIsModalOpen(false);
  };

  return (
    <>
      <AuthorCard
        title={labels.main}
        subtitle={labels.subtitle}
        isEditing={isEditing}
        showOrcid={false}
        user={user}
        options={authorsWithSubmissionUser.map(author => ({
          value: author.email,
          label: `${author.firstName} ${author.lastName}`
        }))}
        defaultValue={userEmail}
        onChange={handleSaveChanges}
        onEdit={handleEditClick}
      />
      {isModalOpen && (
        <AuthorEditModal
          title="Edit Contact Author?"
          description="This role manages important submission communications and commitments. Ensure consensus among all co-authors before making this change to avoid potential conflicts."
          onClose={handleModalClose}
          onConfirm={handleModalConfirm}
        />
      )}
    </>
  );
};

export default ContactAuthor;
